import React from 'react';

import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';

import s from './notification.scss';

/**
 * Display notification after confirmed order on success page
 */
export const Notification = () => {
    const customer = useGetCustomerData();

    return (
        <div className={s.notification}>
            <h2 className={s.header}>Hey {customer.firstname}, before we wrap it up</h2>
            <p className={s.text}>Here are personalized offers to make the most of your glasses</p>
            <div className={s.tax}>* All prices include sales tax if applicable</div>
        </div>
    );
};
